import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkLink from 'react/shared/components/true_link/main/TrueLinkLink';
import theme from 'react/shared/theme/Theme';

const useStyles = makeStyles(() => ({
  text: {
    '&.MuiTypography-root': {
      marginTop: '30px',
      marginBottom: 0,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        textAlign: 'left',
      },
    },
  },
}));

export default function PrivacyPolicyAndTermsOfServiceLinks() {
  const classes = useStyles();
  return (
    <CardText className={classes.text} variant="body2">
      By clicking “Continue” I am agreeing to the True Link{' '}
      <TrueLinkLink href="/legal/privacy-policy" target="_blank">
        Privacy Policy
      </TrueLinkLink>
      {' and website '}
      <TrueLinkLink href="/legal/terms-of-service" target="_blank">
        Terms of Service
      </TrueLinkLink>
    </CardText>
  );
}
